module.exports = __webpack_public_path__ + "static/media/select-background.a76f7a12.png";